import { ApolloClient, InMemoryCache } from '@apollo/client';
import { pipe } from 'fp-ts/lib/function';
import * as T from 'fp-ts/lib/Task';
import * as TE from 'fp-ts/lib/TaskEither';

import { defaultLanguage } from '../../../../../languages';
import { fetchPreferredLangs } from '../api/fetchPreferredLangs';

import { Lang } from '@domain/language-negotiation';

export const negotiateLangByIndividualId = (
  client: ApolloClient<InMemoryCache>,
  individualId: string
): T.Task<Lang> => {
  return pipe(
    fetchPreferredLangs(individualId),
    TE.getOrElse(
      (): T.Task<Lang> => {
        return T.of(defaultLanguage);
      }
    )
  );
};
